<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Payment.Level.Member.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="sUsername">Username </label>
              <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
              &nbsp;&nbsp;
              <label class="mx-sm-2" for="sVIPLevel">Level </label>
              <b-form-select id="sVIPLevel" :plain="true" :options="levels" v-model="sVIPLevel" text-field="Name" value-field="Id">
                <template slot="first">
                  <option :value="null">-- Please select an option --</option>
                </template>
              </b-form-select>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="searchVIPLevelMember"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-user'></i> VIP Level - Member</h3>
              <div class="float-right">
                <b-button variant="info" @click="exportCSV" v-if="checkAccessPrivilege('Payment.Level.Member.Export')">Export</b-button>&nbsp;&nbsp;
                <b-button variant="info" @click="downloadSample" v-if="checkAccessPrivilege('Payment.Level.Member.BatchUpload.Sample')">Excel Sample Download</b-button>&nbsp;&nbsp;
                <b-button variant="success" @click="showBatchUploadModal" v-if="checkAccessPrivilege('Payment.Level.Member.BatchUpload')">Batch Upload</b-button>&nbsp;&nbsp;
                <b-button variant="primary" @click="showManagementModal" v-if="checkAccessPrivilege('Payment.Level.Member.Management')">VIP Level Management</b-button>
              </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
              <template v-slot:cell(action)="data">
                <b-button variant="warning" @click="showChangeVIPLevel(data.item.Id, data.item.LevelId, data.item.MemberId, data.item.Username)" v-if="checkAccessPrivilege('Payment.Level.Member.Change')">Change</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

  <b-modal ref="showBatchUploadModal" size="lg" centered header-bg-variant="primary" hide-footer title="Batch Upload MemberLevel Data">
      <div class="mb-3">
        <label for="groupId">Upload File</label>
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="customFile" @change="handleFileChange">
          <label class="custom-file-label" for="customFile">{{ form.batchUpload.uploadedFileName }}</label>
        </div>
        <small id="passwordHelpBlock" class="form-text text-muted">
          Suppported extension (.xlsx | .xls)
        </small>
        <div v-if="$v.form.batchUpload.uploadFile.$error">
          <div class="invalid-feedback d-block" v-if="!$v.form.batchUpload.uploadFile.required">Please upload file.</div>
          <div class="invalid-feedback d-block" v-if="!$v.form.batchUpload.uploadFile.fileType">Invalid File Format. Must be (.xlsx | .xls)</div>
        </div>
      </div>
      <b-button variant="success" @click="submitBatchUpload" :disabled="$v.form.batchUpload.$error">Upload</b-button>
      <b-button variant="outline-danger" @click="cancelBatchUploadModal">Cancel</b-button>
    </b-modal>

    <b-modal ref="changeVIPLevel" size="lg" centered header-bg-variant="primary" hide-footer title="Change VIP Level">
          <div class="mb-3">
            <label for="cVIPLevel">Level</label>
            <b-form-select id="cVIPLevel" :plain="false" v-model="cVIPLevel" :state="$v.cVIPLevel.$error?false:null" @blur.native="$v.cVIPLevel.$touch">
              <option :value="null">-- Please select --</option>
              <option v-for="d in levels" :key="d.Id" :value="d.Id">{{ d.Name }}</option>
            </b-form-select>
            <div v-if="$v.cVIPLevel.$error">
              <div class="invalid-feedback d-block" v-if="!$v.cVIPLevel.required">VIP level is required</div>
            </div>
          </div>
          <b-button variant="success" @click="changeVIPLevel" :disabled="$v.cVIPLevel.$invalid">Confirm</b-button>
          <b-button variant="outline-danger" @click="cancelChangeVIPLevel">Cancel</b-button>
    </b-modal>
    <b-modal ref="showManagementModal" size="lg" header-bg-variant="primary" hide-footer title="VIP Level Management">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!$v.searchName.$error">
                      <b-input-group>
                        <b-form-input type="text" placeholder="Enter Username for Search" v-model.trim="searchName" :state="$v.searchName.$error?false:null" @focus.native="$v.searchName.$touch"></b-form-input>
                        <b-input-group-button class="input-group-append">
                          <b-btn variant="success" @click="searchMember" :disabled="$v.searchName.$invalid">
                            <i class="fa fa-search"></i> Search
                          </b-btn>
                        </b-input-group-button>
                      </b-input-group>
                      <div v-if="$v.searchName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.searchName.required">Username is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.minLength">Must have at least {{ $v.searchName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.maxLength">Must no exceed {{ $v.searchName.$params.maxLength.max}} letters</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="members" :fields="memberFields" :current-page="memberCurrentPage" :per-page="memberPerPage">
                      <template v-slot:cell(action)="data">
                        <b-button variant="danger" @click="confirmAssignLevel(data.item.Id, data.item.Username)">Assign</b-button>
                      </template>
                    </b-table>
                    <nav>
                      <b-pagination :total-rows="getMemberRowCount(members)" :per-page="memberPerPage" v-model="memberCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="outline-danger" @click="hideManagementModal">Cancel</b-btn>
    </b-modal>
    <b-modal ref="confirmAssignLevel" @hidden="onAssignModalHide" size="lg" centered header-bg-variant="primary" hide-footer title="Assign VIP Level">
          <div class="mb-3">
            <label for="aVIPLevel">Level</label>
            <b-form-select id="aVIPLevel" :plain="false" v-model="aVIPLevel" :state="$v.aVIPLevel.$error?false:null" @blur.native="$v.aVIPLevel.$touch">
              <option :value="null">-- Please select --</option>
              <option v-for="d in levels" :key="d.Id" :value="d.Id">{{ d.Name }}</option>
            </b-form-select>
            <div v-if="$v.aVIPLevel.$error">
              <div class="invalid-feedback d-block" v-if="!$v.aVIPLevel.required">VIP level is required</div>
            </div>
          </div>
          <b-button variant="success" @click="assignVIPLevel" :disabled="$v.aVIPLevel.$invalid">Confirm</b-button>
          <b-button variant="outline-danger" @click="cancelAssignLevel">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  const moment = require('moment-timezone')

  export default {
    name: 'vip-level-member-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        members: [],
        levels: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'LevelName', label: 'Level'},
          {key: 'action', label: 'Action'}
        ],
        memberFields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        memberCurrentPage: 1,
        perPage: 30,
        memberPerPage: 10,
        totalMemberRows: 0,
        rowCount: 0,
        operator: '',
        searchName: '',
        changeId: '',
        cMemberId: '',
        cMemberUsername: '',
        cVIPLevel: null,
        sUsername: '',
        sVIPLevel: null,
        assignId: '',
        assignUsername: '',
        aVIPLevel: null,
        form: {
          batchUpload: {
            uploadedFileName: 'Choose File',
            uploadFile: ''
          }
        }
      }
    },
    validations: {
      searchName: { required, minLength: minLength(5), maxLength: maxLength(20) },
      cVIPLevel: { required },
      aVIPLevel: { required },
      form: {
        batchUpload: {
          uploadFile: {
            required,
            fileType: function (e) {
              if (!e) return true
              let type = e.name ? e.name.split('.').reverse()[0] : ''
              return (type !== '' && (type === 'xlsx' || type === 'xls'))
            }
          }
        }
      }
    },
    watch: {
      currentPage: function () {
        this.searchVIPLevelMember()
      },
      currentMemberPage: function () {
        this.searchMember()
      }
    },
    methods: {
      handleFileChange (e) {
        this.form.batchUpload.uploadedFileName = e.target.files[0].name
        this.form.batchUpload.uploadFile = e.target.files[0]
      },
      getRowCount (items) {
        return this.rowCount
      },
      getMemberRowCount (members) {
        return members.length
      },
      getVIPLevels () {
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/levels', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.levels = response.data.levels
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchMember () {
        this.$http.post(this.API_ENDPOINT + '/member/search', {searchName: this.searchName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.members = response.data.members
          this.totalMemberRows = response.data.members.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchVIPLevelMember () {
        let username = this.sUsername
        let vipLevel = this.sVIPLevel || ''
        let page = this.currentPage
        let size = this.perPage
        let queryStr = `?size=${size}&page=${page}&username=${username}&level=${vipLevel}`
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/member/search' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
          this.rowCount = response.data.rowCount
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      async exportCSV () {
        try {
          let username = this.sUsername
          let vipLevel = this.sVIPLevel || ''
          let queryStr = `?username=${username}&level=${vipLevel}`
          let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/viplevel/member/search/export' + queryStr, { responseType: 'blob', headers: { 'Content-Type': 'application/json' } })
          let url = window.URL.createObjectURL(new Blob([ data ]))
          let link = document.createElement('a')
          link.href = url
          let fileName = `vip_member_level_log_${moment().format('YYYYMMDD')}.csv`
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      changeVIPLevel () {
        this.$http.post(this.API_ENDPOINT + '/payment/viplevel/member/set', {'id': this.changeId, 'newLevel': this.cVIPLevel}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchVIPLevelMember()
            this.cancelChangeVIPLevel()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'VIP Level Changed')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      assignVIPLevel () {
        this.$http.post(this.API_ENDPOINT + '/payment/viplevel/member/assign', {'memberId': this.assignId, 'username': this.assignUsername, 'level': this.aVIPLevel}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchVIPLevelMember()
            this.cancelAssignLevel()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'VIP Level Assigned')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      async submitBatchUpload () {
        try {
          this.$v.form.batchUpload.$touch()
          if (this.$v.form.batchUpload.$error) {
            return true
          } else {
            let data = new FormData()
            data.append('file', this.form.batchUpload.uploadFile)
            data.append('operator', this.operator)

            await this.$http.post(this.API_ENDPOINT + '/payment/viplevel/member/batchAssign', data)
            this.getVIPLevels()
            this.cancelBatchUploadModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Batch Member Uploaded Successfully')
          }
        } catch (error) {
          console.log('this is an error', error)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async downloadSample () {
        try {
          let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/viplevel/member/batchAssign/sample', { responseType: 'blob', headers: { 'Content-Type': 'application/json' } })
          let url = window.URL.createObjectURL(new Blob([ data ]))
          let link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Member_Level_Batch_Upload_Sample.csv`)
          link.click()
          alert('Change the file extension to .xlsx or .xls')
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      showChangeVIPLevel (id, level, memberId, username) {
        this.changeId = id
        this.cVIPLevel = level
        this.cMemberId = memberId
        this.cMemberUsername = username
        this.$refs.changeVIPLevel.show()
      },
      cancelChangeVIPLevel () {
        this.$refs.changeVIPLevel.hide()
      },
      showManagementModal () {
        this.$refs.showManagementModal.show()
      },
      hideManagementModal () {
        this.$refs.showManagementModal.hide()
      },
      confirmAssignLevel (id, username) {
        this.assignId = id
        this.assignUsername = username
        this.$refs.confirmAssignLevel.show()
      },
      cancelAssignLevel () {
        this.$refs.confirmAssignLevel.hide()
      },
      onAssignModalHide () {
        this.$refs.showManagementModal.show()
      },
      showBatchUploadModal () {
        this.$refs.showBatchUploadModal.show()
      },
      cancelBatchUploadModal () {
        this.form.batchUpload.uploadedFileName = ''
        this.form.batchUpload.uploadFile = ''
        this.$v.form.batchUpload.$reset()
        this.$refs.showBatchUploadModal.hide()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
      this.getVIPLevels()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelMemberTable.vue